import * as React from "react";

// Top-view flower pot with colorful petals
function FlowerIcon({ color = "#E91E63", width = 40, height = 40, name }) {
  return (
    <div style={{ textAlign: "center" }}>
      {name && <p style={{ margin: 0, fontSize: "10px", userSelect: "none" }}>{name}</p>}
      <svg
        viewBox="0 0 100 100"
        height={height}
        width={width}
      >
        {/* Pot */}
        <circle cx="50" cy="50" r="45" fill="#D7CCC8" />
        <circle cx="50" cy="50" r="38" fill="#BCAAA4" />
        {/* Soil */}
        <circle cx="50" cy="50" r="32" fill="#5D4037" />
        {/* Flower petals - top view */}
        <ellipse cx="50" cy="25" rx="14" ry="20" fill={color} />
        <ellipse cx="50" cy="25" rx="14" ry="20" fill={color} transform="rotate(72 50 50)" />
        <ellipse cx="50" cy="25" rx="14" ry="20" fill={color} transform="rotate(144 50 50)" />
        <ellipse cx="50" cy="25" rx="14" ry="20" fill={color} transform="rotate(216 50 50)" />
        <ellipse cx="50" cy="25" rx="14" ry="20" fill={color} transform="rotate(288 50 50)" />
        {/* Flower center */}
        <circle cx="50" cy="50" r="12" fill="#FFC107" />
        <circle cx="50" cy="50" r="6" fill="#FF9800" />
      </svg>
    </div>
  );
}

export default FlowerIcon;
